import axios from "axios";

export default {
  state: {
    list: [],
    isLoadingAuthUser: false,
  },
  actions: {
    getPlatforms({commit, state}) {
      state.isLoadingAuthUser = true;
      return axios.get('/api/v1/platform')
        .then(({data: {data: platforms} }) => {
          commit('SET_PLATFORMS', platforms.filter((p) => p.id != 4))
        })
    },
  },
  mutations: {
    SET_PLATFORMS(state, platforms) {
      state.list = platforms
    },
  },
  getters :{
    platforms: state => state.list,
  }
};
